import { render, staticRenderFns } from "./ProfessionList.vue?vue&type=template&id=01e5e89d&scoped=true"
import script from "./ProfessionList.vue?vue&type=script&lang=js"
export * from "./ProfessionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e5e89d",
  null
  
)

export default component.exports